/* import __COLOCATED_TEMPLATE__ from './error-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationError } from '../conversation-item';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export interface ConversationArgs {
  conversationItem: FormattedConversationError;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class ErrorConversationItem extends Component<Signature> {
  @tracked isExpanded = false;

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::ErrorConversationItem': typeof ErrorConversationItem;
  }
}
